import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import {
  HeroFullAsymmetric,
  HeroFullBlock,
  HeroFullCombined,
} from '@cotyorg/ccx-organism-hero';
import Breadcrumbs from '@cotyorg/ccx-molecules/Breadcrumbs';
import StandardLayout from '../../templates/StandardLayout';

const SallyStoryComponent = ({ textSections, pageSections, breadcrumb }) => (
  <StandardLayout>
    <Breadcrumbs items={breadcrumb} />

    <div className="sally-story">
      <div className="main-hero-section">
        <div className="grid-container">
          <div className="grid-x">
            <div className="cell xsmall-16">
              <HeroFullAsymmetric
                heroStoreDataKey="hero1"
                alignment="bottom"
                isUnderlined={false}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="sally-story__section">
        <div className="grid-container">
          <div className="grid-x grid-padding-x">
            <div className="cell xsmall-16 large-10 large-offset-3">
              <div className="grid-x grid-padding-x">
                <div className="cell xsmall-16">
                  <Paragraph extraClass="sally-story__intro-copy">
                    {R.prop('textIntroduction', textSections)}
                  </Paragraph>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {pageSections.map((section, index) => (
        <>
          <div className="grid-container">
            <div className="grid-x grid-padding-x">
              <div className="cell xsmall-16 large-14 large-offset-1">
                <div className="sally-story__section" key={uuid()}>
                  {R.prop('heading', section) && R.prop('subheading', section) && (
                    <div className="grid-x grid-padding-x">
                      <div className="cell xsmall-16 text--center">
                        <header className="sally-story__section-header">
                          <Heading
                            level={2}
                            extraClass="sally-story__section-heading"
                          >
                            {R.prop('heading', section)}
                          </Heading>

                          <Heading level={3}>
                            {R.prop('subheading', section)}
                          </Heading>
                        </header>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {index === 4 && (
            <HeroFullCombined
              heroStoreDataKey={`hero${index + 2}`}
              layout="vertical"
              backgroundType="transparent"
              isUnderlined={false}
              headingLevel={1}
            />
          )}

          {index !== 4 && (
            <div className="grid-container">
              <div className="grid-x grid-padding-x">
                <div className="cell xsmall-16 large-14 large-offset-1">
                  <HeroFullBlock
                    heroStoreDataKey={`hero${index + 2}`}
                    backgroundType="transparent"
                    isUnderlined={false}
                    headingLevel={1}
                    isContentFirst={index % 2 !== 0}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      ))}
    </div>
  </StandardLayout>
);

SallyStoryComponent.propTypes = {
  breadcrumb: PropTypes.arrayOf(PropTypes.object),
  textSections: PropTypes.objectOf(PropTypes.string),
  pageSections: PropTypes.arrayOf(PropTypes.object),
};

export default connect(({ content }) => ({
  breadcrumb: R.prop('breadcrumb', content),
  textSections: R.prop('textSections', content),
  pageSections: R.prop('pageSections', content),
}))(SallyStoryComponent);
